<template>
  <Dialog
    :title="title"
    :visible="visible"
    @close="handleClose"
    width="500px"
  >
    <Form
      ref="form"
      :model="form"
      :rules="rules"
      label-width="110px"
    >
      <FormItem
        label="前端权限名称"
        prop="action"
      >
        <Input
          v-model="form.action"
          :disabled="type !== 'add'"
        />
      </FormItem>
      <FormItem
        label="权限组名称"
        prop="name"
      >
        <Input v-model="form.name" />
      </FormItem>
      <FormItem
        label="是否检查权限"
        prop="state"
      >
        <ElmSwitch
          v-model="form.state"
          :active-value="1"
          :inactive-value="0"
        />
      </FormItem>
      <FormItem
        label="父级ID"
        prop="pid"
      >
        <Input
          v-model="form.pid"
          disabled
        />
      </FormItem>
      <FormItem
        label="是否需要登录"
        prop="check_login"
      >
        <ElmSwitch
          v-model="form.check_login"
          :active-value="1"
          :inactive-value="0"
        />
      </FormItem>
    </Form>

    <span slot="footer">
      <Button @click="handleClose">取消</Button>
      <Button
        type="primary"
        @click="confirm"
      >
        确定
      </Button>
    </span>
  </Dialog>
</template>

<script>
import { Dialog, Form, FormItem, Input, Switch, Button } from 'element-ui';

export default {
  components: {
    Dialog,
    Form,
    FormItem,
    Input,
    ElmSwitch: Switch,
    Button,
  },

  props: {
    dataSource: {
      type: Object,
      default() {
        return null;
      },
    },

    visible: {
      type: Boolean,
      default: false,
    },

    type: {
      type: String,
      default: 'add',
    },
  },

  data() {
    return {
      form: {
        action: '',
        name: '',
        state: 0,
        pid: 0,
        check_login: 0,
      },
      rules: {
        action: [
          { required: true, message: '请输入前端权限名称', trigger: 'blur' },
        ],
        name: [
          { required: true, message: '请输入权限组名称', trigger: 'blur' },
        ],
      },
    };
  },

  computed: {
    title() {
      return this.type === 'add' ? '新增权限组' : '修改权限组';
    },
  },

  watch: {
    visible(newVal) {
      if (newVal) {
        if (this.type === 'add') {
          this.form.pid = this.dataSource ? this.dataSource.id : 0;
        } else if (this.type === 'update') {
          this.form.action = this.dataSource.action;
          this.form.name = this.dataSource.name;
          this.form.state = Number(this.dataSource.state);
          this.form.pid = this.dataSource.pid;
          this.form.check_login = Number(this.dataSource.check_login);
          this.form.id = this.dataSource.id;
        }
      }
    },
  },

  methods: {
    confirm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$emit('confirm', this.form);
          this.$refs.form.resetFields();
          this.handleClose();
        }
      });
    },

    handleClose() {
      this.$emit('update:visible', false);
    },
  },
};
</script>